import { useState, useCallback } from 'react';

interface ToastProps {
  message: string;
  duration?: number;
}

export function useToast() {
  const [toast, setToast] = useState<ToastProps | null>(null);

  const showToast = useCallback((message: string, duration = 2000) => {
    setToast({ message, duration });
    setTimeout(() => setToast(null), duration);
  }, []);

  const ToastComponent = toast ? (
    <div className={`toast ${toast ? 'show' : ''}`}>
      {toast.message}
    </div>
  ) : null;

  return { showToast, ToastComponent };
}
